// Querys and Mutations
import {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE
} from '@/graphql/config/SubAreaGraphql'

// models
import { Paginator, ResponseDefault } from '@/models'
import { SubAreaForm, SubAreaModel, SubAreasWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class SubAreaService {
    /**
     * Queries
     */
    async getActivated (): Promise<SubAreaModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.subAreasActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<SubAreasWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.subAreasWithPagination.paginatorInfo
        const data: [SubAreaModel] = result.data.subAreasWithPagination.data
        const response: SubAreasWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
    async create (form: SubAreaForm): Promise<SubAreaModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createSubArea
    }

    async update (id: number, form: SubAreaForm): Promise<SubAreaModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateSubArea
    }

    async changeStatus (id: number, status: boolean): Promise<SubAreaModel> {
        const result = await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return result.data.updateSubArea
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new SubAreaService()
